import { OperationType } from './../../../widgets/filters/miscellaneous/operation-type.enum';
import { QueryFilterParameter } from './../../../widgets/filters/models/query-filter-parameter.model';
import { HelpService } from './../../help/help.service';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import {
  StockService,
  DrillInfo,
  ColorizationOption,
  OverviewFilterInput,
  OverviewFiltersOutput,
  TaskDataFilter,
  ValidFilters
} from "../stock.service";
import { DynamicTable } from "src/app/models/dynamicTable";
import { ActivatedRoute, Router } from "@angular/router";
import { HtmlControlType } from "src/app/enums/htmlControlType";
import { DropdowndSelectedValues } from "src/app/widgets/dropdown-filter/dropdown-filter.component";
import { ShareDataService } from 'src/app/services/share-data.service';
import { TaskService } from '../../task/task.service';
import { Title } from '@angular/platform-browser';
import { BookmarkData } from 'src/app/models/Bookmark';
import { ExportFilter, FilterInput, FilterMappingService} from 'src/app/models/filter-objects';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

import { FileExportService } from 'src/app/common/file-export-service';


import dxTreeMap from 'devextreme/viz/tree_map';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: "app-heat-map",
    templateUrl: "./heat-map.component.html",
    styleUrls: ["./heat-map.component.scss"],
    standalone: false
})
export class HeatMapComponent implements OnInit, AfterViewInit {
  heatMapData = [];
  private heatMapCrossData = [];
  private groupFieldName = [];
  drillInfos: DrillInfo[] = [];
  options: any;
  colorizationOptions: ColorizationOption[] = [];
  resizableContainer = 0;

  isPageLoad: boolean = false;

  action = "Filter";

  htmlControlType = HtmlControlType;

  filterList: OverviewFilterInput[] = [];
  filterOptions: OverviewFiltersOutput;
  allFilters: OverviewFilterInput[] = [];
  resetFiltersItems: string[] = [];

  filterparam: ValidFilters;

  @ViewChild('dxtreeMapData', { static: false }) treeMapData: dxTreeMap;

  private getFiltersData() {
    this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.filterOptions.filters);
    this.stockService.getHeatMapFilters(this.filterOptions.filters).subscribe(
      (res) => {
        //convert received data to table structure for drop down
        res.forEach((item) => {
          item.values = item.values ? item.values : [];
          this.filterOptions.filters = this.filterOptions.filters
            ? this.filterOptions.filters
            : [];

          item.values = item.values.map((all) => ({ all }));
          item.selectedValues = this.filterOptions.filters
            .filter((filterItem) => filterItem.fieldName === item.selectionName)
            .map((filterItem) => filterItem.value);
          if (item.defaultFilterValue != null && item.defaultFilterValue != '' && item.values.length > 0 && this.isPageLoad) {
            item.selectedValues = [item.defaultFilterValue];
          }
        });
        this.allFilters = res;
        this.filterList = res;

        if (this.isPageLoad) {
          this.isPageLoad = false;
          this.filterOptions.filters = [];
          this.filterList.forEach((item) => {
            if (item.selectedValues != null && item.selectedValues.length > 0) {
              item.selectedValues.forEach(element => {
                let filteItem: QueryFilterParameter = new QueryFilterParameter(
                  item.selectionName,
                  element,
                  OperationType.Contains
                );
                this.filterOptions.filters.push(filteItem);
              });
            }
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  setTextBoxFilterOptions(selectionId: number, el: any) {
    if (el.value) {
      this.filterList.forEach((item) => {
        if (item.selectionId === selectionId) {
          let arr: string[] = [];
          arr.push(el.value);
          item.selectedValues = arr;
        }
      });
    }
  }

  private getData() {
    this.stockService
      .getHeatMapData(this.filterOptions)
      .toPromise()
      .then((data) => {
        if (data) {
          this.initMapData(data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  applyFilters() {
    this.drillInfos = [];
    let filters: QueryFilterParameter[] = [];
    if (this.filterOptions.filters) {
      this.filterList.forEach((item) => {
        if (item.selectedValues && item.selectedValues.length > 0) {
          item.selectedValues.forEach((el) => {
            let filter = new QueryFilterParameter(
              item.selectionName,
              el,
              OperationType.Equals
            );

            filters.push(filter);
          });
        }
      });
    }

    this.filterOptions.filters = filters;
    this.shareDataService.CleanData();
    this.shareDataService.filterOptionOverview = this.filterOptions;
    this.getFiltersData();
    this.getData();
  }

  resetFilters() {
    this.filterOptions.filters = [];
    this.filterList.map((item) => (item.selectedValues = []));
    this.filterList.forEach((item) => {
      if (item.defaultFilterValue) {
        item.selectedValues = [item.defaultFilterValue];
      } else {
        item.selectedValues = [];
      }
    });
    this.applyFilters();
    this.resetFiltersItems = [];
    if (this.treeMapData != null && this.treeMapData.resetDrillDown != null) {
      this.treeMapData.resetDrillDown();
    }
    this.drillInfos = [];
    console.log(this.treeMapData, "treeMapData*************");
  }

  selectedItemsChanged(event: DropdowndSelectedValues) {
    this.filterList
      .filter((item) => item.selectionId === event.selectionId)
      .forEach((item) => (item.selectedValues = event.values));
  }

  @ViewChild("heatMapContainer", { static: false })
  heatMapContainer: ElementRef;
  constructor(private stockService: StockService, private router: Router, private helpService: HelpService,
    private taskService: TaskService, private shareDataService: ShareDataService, private titleService: Title,
    private route: ActivatedRoute, private fileExportService: FileExportService) {
    this.shareDataService.CleanData();
  }

  private initFilterOptions() {
    this.filterOptions = new OverviewFiltersOutput();
    this.filterOptions.action = this.action;
    this.filterOptions.settingGroupId = 1;
    this.filterOptions.filters = [];
    this.getFiltersData();
  }

  taskFilterData: TaskDataFilter[];
  IsTaskLoad = false;
  ngOnInit() {

    this.titleService.setTitle("Stock Heat Map");
    this.route.paramMap.subscribe(
      params => {
        const value = this.route.snapshot.queryParamMap.get("taskid");
        if (value) {

          //default load with parameters
          this.filterOptions = new OverviewFiltersOutput();
          this.filterOptions.action = this.action;
          this.filterOptions.settingGroupId = 1;
          this.filterOptions.filters = [];
          //loading filter data

          this.taskService.SelectTaskFilterValues(value).subscribe(data => {
            this.taskFilterData = data;
            this.taskFilterData.forEach(element => {
              let filterItem: QueryFilterParameter = new QueryFilterParameter(
                element.fieldName,
                element.settingValue,
                OperationType.Contains
              );

              this.filterOptions.filters.push(filterItem);
            });
            this.IsTaskLoad = true;
            this.getFiltersData();

            this.getData();
          }, err => {

          });

        }
        else {
          this.dataFilter = new BookmarkData();
          this.dataFilter.BookmarkId = 0;
          this.dataFilter.name = "DefBokmk";
          this.dataFilter.pageName = this.pageName;
          this.loadBookMarkFilter();
        }
      });

    this.initColoriztionOptios();
    this.GetSettingsData();

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.resizableContainer = this.heatMapContainer.nativeElement.offsetWidth;
    }, 500);
  }
  initHeadMapData() {
    this.filterparam = new ValidFilters();
    this.filterparam.action = this.action;
    this.filterparam.filters = this.filterOptions.filters;

    this.stockService
      .getHeadMapData(this.filterparam)
      .subscribe((res) => {
        this.initMapData(res.data);
      });
  }
  private initMapData(table: DynamicTable) {
    this.heatMapCrossData = [];
    this.groupFieldName = table.fieldsNames;
    table.rows
      .map((row) => row.fields.map((fild) => fild))
      .forEach((item) => {
        let createRow = {};
        item.forEach((el) => {
          createRow[el.name] = el.value;
        });
        this.heatMapCrossData.push(createRow);
      });
    this.initTree();

  }

  private initTree() {
    if (!this.groupFieldName || !this.groupFieldName.length) {
      this.heatMapData = [];
      return;
    }

    this.heatMapData = this.createTreeLevel(0, []);
  }

  private createTreeLevel(
    level: number,
    parentLevels: ParentLevel[]
  ): TreeElement[] {
    let fieldName = this.groupFieldName[level];

    if (!fieldName) {
      return null;
    }

    if (typeof this.heatMapCrossData[0][fieldName] !== "string") {
      return this.createTreeLevel(level + 1, parentLevels);
    }

    let result: TreeElement[] = [];

    for (let i = 0; i < this.heatMapCrossData.length; i++) {
      const element = this.heatMapCrossData[i];
      let existingElement = result.filter(
        (item) => item.name === element[fieldName]
      );

      if (
        parentLevels &&
        parentLevels.length &&
        parentLevels.filter(
          (parent) => element[parent.fieldName] === parent.value
        ).length !== parentLevels.length
      ) {
        continue;
      }

      if (!existingElement.length) {
        let newParentLevels = Object.assign([], parentLevels);
        newParentLevels.push(new ParentLevel(fieldName, element[fieldName]));

        let openDeepDive = fieldName === "ProductId";
        let children =
          fieldName === "ProductId"
            ? []
            : this.createTreeLevel(level + 1, newParentLevels);
        let newElement = new TreeElement(
          element[fieldName],
          element.StockAmount,
          children,
          openDeepDive
        );
        result.push(newElement);
      } else {
        existingElement[0].value += element.StockAmount;
      }
    }
    return result;
  }

  treeMapClick(event: any) {
    let data = event.node.data as TreeElement;

    if (data && data.openDeepDive) {
      let url = "stock/deep-dive?id=" + UtilsService.getURLHelper(data.name);
      window.open(url, "_blank");
    }

    event.node.drillDown();
  }

  nodeClick(e) {
    e.node.drillDown();
  }

  drill(e) {
    this.drillInfos = [];
    for (let node = e.node.getParent(); node; node = node.getParent()) {
      this.drillInfos.unshift({
        text: node.label() || "All",
        node: node,
      });
    }
    if (this.drillInfos.length) {
      this.drillInfos.push({
        text: e.node.label(),
      });
    }
  }

  drillInfoClick(node) {
    if (node) {
      node.drillDown();
    }
  }

  initColoriztionOptios() {
    this.colorizationOptions = [{
      name: 'Discrete',
      options: {
        type: 'discrete',
        palette: 'harmony light',
        colorizeGroups: false,
      },
    }, {
      name: 'Grouped',
      options: {
        type: 'discrete',
        palette: 'harmony light',
        colorizeGroups: true,
      },
    }, {
      name: 'Range',
      options: {
        type: 'range',
        palette: ['#fbd600', '#78299a'],
        range: [0, 50000, 100000, 150000, 200000, 250000],
        colorCodeField: 'salesAmount',
        colorizeGroups: false,
      },
    }, {
      name: 'Gradient',
      options: {
        type: 'gradient',
        palette: ['#fbd600', '#78299a'],
        range: [10000, 250000],
        colorCodeField: 'salesAmount',
        colorizeGroups: false,
      },
    }];
    console.log(this.colorizationOptions[3].options, "this.colorizationOptions");
    this.options = this.colorizationOptions[3].options;
  }

  customizeTooltip(arg) {
    var data = arg.node.data;
    var result = "";
    try {
      result = "<span class='product'>" + data.name + "</span><br/>" + UtilsService.FormatNumberWithDecimalPlaces(arg.value);
    }
    catch (e) {
      result = "<span class='product'>" + data.name + "</span><br/>" + arg.value;
    }

    return {
      text: result,
    };
  }



  onResize() {
    setTimeout(() => {
      this.resizableContainer = this.heatMapContainer.nativeElement.offsetWidth;
    });
  }

  public onHelpButtonClicked(event, settingName: string) {
    this.helpService.openHelpPage(settingName);
  }

  //bookmark
  pageName: string = "StockHeatMap";
  currentlySelectedFilters: FilterInput[] = [];
  dataFilter: BookmarkData;

  loadBookMarkFilterClick(data) {
    if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
      this.filterOptions.filters = [];
      this.filterList.map(item => item.selectedValues = []);
      this.resetFiltersItems = [];
      this.currentlySelectedFilters = [];
      this.dataFilter = new BookmarkData();
      this.dataFilter.BookmarkId = data.bookmarkId;
      this.dataFilter.name = "Bokmk";
      this.dataFilter.pageName = this.pageName;
      this.loadBookMarkFilter();
    }
  }

  loadBookMarkFilter() {
    this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
      this.taskFilterData = data;
      if (this.taskFilterData != null && this.taskFilterData != undefined && this.taskFilterData.length > 0) {
        //default load with parameters
        this.filterOptions = new OverviewFiltersOutput();
        this.filterOptions.action = this.action;
        this.filterOptions.settingGroupId = 1;
        this.filterOptions.filters = [];
        this.taskFilterData.forEach(element => {
          let filteItem: QueryFilterParameter = new QueryFilterParameter(
            element.fieldName,
            element.settingValue,
            OperationType.Contains
          );

          this.filterOptions.filters.push(filteItem);
        });
        this.IsTaskLoad = true;
        this.getFiltersData();
        this.getData();
      }
      else {
        this.isPageLoad = true;
        this.initFilterOptions();
        this.getData();
      }
    }, err => {
    });

  }

  /* Export Forecast Option */
  filterMappingService = new FilterMappingService();
  ExportToExcelFilters: ExportFilter[] = [];
  IsExportEnable = false;
  GetSettingsData() {
    this.fileExportService.WebSettings("EnableExportStockHeatMap").subscribe(resultFilename => {
      this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
    }, err => {
      console.log(err);
    });
  }

}

export class ParentLevel {
  fieldName: string;
  value: string;

  constructor(fieldName: string, value: string) {
    this.fieldName = fieldName;
    this.value = value;
  }
}

export class TreeElement {
  name: string;
  value: number = 0;
  items: TreeElement[];
  openDeepDive: boolean;

  constructor(
    name: string,
    value: number,
    items: TreeElement[],
    openDeepDive: boolean
  ) {
    this.name = name;
    this.value = value;
    this.items = items;
    this.openDeepDive = openDeepDive;
  }

}
